import Vue from 'vue'
import VueRouter from 'vue-router'
// Sørg for at stien her passer til din axios-fil
import { cancelPendingRequests } from '../axios/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/404',
    name: '404',
    redirect: '/',
    component: require('@/pages/common/404')
},
{
    path: '*',
    redirect: '/'
},
{
  path: '/',
  name: 'Index',
  component: require('@/pages/index/index.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/mulige-indsatser',
  name: 'PossibleEfforts',
  component: require('@/pages/possibleEfforts.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/oekonomi',
  name: 'Economy',
  component: require('@/pages/economy/economy.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: 'drift',
      name: 'EconomyOperations',
      component: require('@/pages/economy/operations.vue')
    },
    {
      path: 'oekonomi',
      name: 'EconomyLearning',
      component: require('@/pages/economy/learning.vue')
    }
  ]
},
{
  path: '/kunder',
  name: 'Customers',
  component: require('@/pages/customers/customers.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: 'drift',
      name: 'CustomersOperations',
      component: require('@/pages/customers/operations.vue')
    },
    {
      path: 'udvikling-og-laering',
      name: 'CustomersLearning',
      component: require('@/pages/customers/learning.vue')
    }
  ]
},
{
  path: '/opgaver',
  name: 'Projects',
  component: require('@/pages/projects/projects.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: 'drift',
      name: 'ProjectsOperations',
      component: require('@/pages/projects/operations.vue')
    },
    {
      path: 'udvikling-og-laering',
      name: 'ProjectsLearning',
      component: require('@/pages/projects/learning.vue')
    }
  ]
},
{
  path: '/medarbejdere',
  name: 'Employees',
  component: require('@/pages/employees/employees.vue'),
  meta: {
    auth: true
  },
  children: [
    {
      path: 'drift',
      name: 'EmployeesOperations',
      component: require('@/pages/employees/operations.vue')
    },
    {
      path: 'udvikling-og-laering',
      name: 'EmployeesLearning',
      component: require('@/pages/employees/learning.vue')
    }
  ]
},
{
  path: '/ansvarlige',
  name: 'Responsibles',
  component: require('@/pages/responsibles/index.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/potentiale',
  name: 'Potential',
  component: require('@/pages/potential/index.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/budget-laegning',
  name: 'BudgetPlanning',
  component: require('@/pages/budget/index.vue'),
  meta: {
    auth: true
  }
},
{
  path: '/register',
  name: 'Register',
  component: require('@/pages/register/register.vue'),
  meta: {
    auth: false
  }
},
{
  path: '/login',
  name: 'Login',
  component: require('@/pages/login/login.vue'),
  meta: {
    auth: false
  }
},
{
  path: '/indstillinger',
  name: 'Settings',
  component: require('@/pages/settings/index'),
  meta: {
    auth: true
  }
},
{
  path: '/entreprise',
  name: 'Enterprise',
  component: require('@/pages/enterprise/index'),
  meta: {
    auth: true
  }
},
{
  path: 'skift-virksomhed',
  name: 'ChangeCompany',
  component: require('@/pages/settings/components/changeCompany'),
  meta: {
    auth: true
  }
},
{
  path: '/super-admin',
  name: 'SuperAdmin',
  component: require('@/pages/superadmin/index'),
  meta: {
    auth: true
  }
},
{
  path: '/kommer-snart',
  name: 'ComingSoon',
  component: require('@/pages/common/comingsoon'),
  meta: {
    auth: true
  }
},
{
  path: '/tips',
  name: 'Tips',
  component: require('@/pages/common/tips'),
  meta: {
    auth: true
  }
}
]

const router = new VueRouter({
  mode: 'history', // Dette svarer til createWebHistory i den nye version
  routes
})

// Dette er den vigtige del, der stopper dine kald ved sideskift
// Undtag: login navigation og initial page load (refresh)
router.beforeEach((to, from, next) => {
  const isInitialNavigation = from.matched.length === 0
  const isFromLogin = from.path === '/login'

  if (to.path !== from.path && !isInitialNavigation && !isFromLogin) {
    cancelPendingRequests()
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js